import { t } from '@/utils/i18n'
import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import Icon from '@/components/Icon/Icon'
import styles from './Tabbar.module.less'
import { common, routesMap } from '@/utils'
import { useCartStore, useCorpInfoStore } from '@/stores'

const { hasHomeModule } = common

interface TabbarProps {
  showBorderTop?: boolean
  background?: string
  borderColor?: string
  zIndex?: string
}

interface IMenuItem {
  url: string
  show: boolean // 是否显示
  name: string // 名称
  type: string // 菜单索引值
  number: number // 菜单右上角数字，大于0时才显示
  iconName: string // 字体图标名称
  iconNameActive?: string // active 字体图标名称
}

const NAV_OPTIONS = {
  color: {
    normal: '#222222', // 正常颜色
    selected: '#fe5700', // 选中颜色
  },
  iconType: 'icon', // 图标类型，iconfont=字体图标；img=图片图标
  iconSize: 40, // 字体图标大小
  imgSize: '40px', // 图片图标大小
  jumpType: 'redirectTo', // 跳转类型
}

const Tabbar: React.FC<TabbarProps> = ({
  showBorderTop = false,
  background = '#fff',
  borderColor = '#e5e5e5',
  zIndex = '10',
}) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { cart } = useCartStore()
  const { corpInfo } = useCorpInfoStore()
  const [nav] = useState(NAV_OPTIONS)
  const [menus, setMune] = useState<IMenuItem[]>([])
  const [selectedIndex, setSelectedIndex] = useState(-1)
  const initBdStyle = {
    background,
    zIndex,
    borderTop: showBorderTop ? `1px solid ${borderColor}` : 'none',
  }

  const MENU_ITEMS: IMenuItem[] = [
    {
      show: true, // 是否显示
      name: t('首页'), // 名称
      type: 'home', // 菜单索引值
      number: 0, // 菜单右上角数字，大于0时才显示
      url: '/', // 菜单跳转url
      iconName: 'home', // 字体图标名称
      iconNameActive: 'home-active',
    },
    {
      show: true,
      name: t('全部货品'),
      type: 'category',
      number: 0,
      url: '/products',
      iconName: 'goods',
      iconNameActive: 'goods-active',
    },
    {
      show: true,
      name: t('购物车'),
      type: 'cart',
      number: 0,
      url: '/shopping-cart',
      iconName: 'cart',
      iconNameActive: 'cart-active',
    },
    {
      show: true,
      name: t('我的'),
      type: 'mine',
      number: 0,
      url: '/my-center',
      iconName: 'mine',
      iconNameActive: 'mine-active',
    },
  ]

  const getMenuItems = async () => {
    const homeModule = await hasHomeModule()

    if (homeModule) {
      return MENU_ITEMS
    }

    return MENU_ITEMS.filter((item) => item.type !== 'home')
  }

  useEffect(() => {
    getMenuItems().then((res) => {
      const newMenus = res.map((item) => {
        if (item.type === 'cart') {
          item.number = cart.productCount
        }

        return item
      })

      setMune(newMenus)
    })
  }, [cart.productCount])

  useEffect(() => {
    const pathname = location.pathname
    const index = menus.findIndex((item, index) => {
      // 从首页跳转到分类搜索也显示首页高亮
      if (pathname === routesMap.CategorySearch && index === 0) return true

      return item.url === pathname
    })

    setSelectedIndex(index || 0)
  }, [location, menus])

  function handleGoto(index: number) {
    if (!corpInfo?.accountId && ['cart', 'mine'].includes(menus[index]?.type)) {
      common.logout()
      // navigate(routesMap.Login)
      return
    }

    const path = menus[index]?.url
    navigate(path)
  }

  const getNumClassName = (number: number) => {
    let className = `${styles['nav-item-num']} ` // 默认 className 'nav-item-num'
    if (number < 10) {
      className += `${styles.small}`
    } else if (number >= 10 && number < 100) {
      className += `${styles.normal}`
    } else {
      className += `${styles.big}`
    }
    return className
  }

  const MenuItem = () => {
    return menus.map((item, index) => {
      return item.show ? (
        <button
          onClick={() => handleGoto(index)}
          key={index}
          style={{ background }}
          className={styles['nav-item']}
        >
          <div className={styles['nav-item-main']}>
            {nav.iconType === 'icon' ? (
              <Icon
                name={`${
                  index === selectedIndex ? item.iconNameActive : item.iconName
                }`}
                size={String(nav.iconSize)}
                color={
                  index === selectedIndex
                    ? nav.color.selected
                    : nav.color.normal
                }
              />
            ) : (
              ''
            )}
            {/* 菜单名称 */}
            <div
              className={styles['nav-item-main-name']}
              style={{
                ...{
                  color:
                    index === selectedIndex
                      ? nav.color.selected
                      : nav.color.normal,
                },
              }}
            >
              {item.name}
            </div>
          </div>
          {/* 图标右上角数字 */}
          {item.number > 0 ? (
            <div className={getNumClassName(item.number)}>
              {item.number >= 100 ? '99+' : item.number}
            </div>
          ) : (
            ''
          )}
        </button>
      ) : (
        ''
      )
    })
  }

  return (
    <div className={styles.nav} id="I_tabbar">
      <div className={styles.placeholder}></div>
      <div className={styles.bd} style={{ ...initBdStyle }}>
        <MenuItem />
      </div>
    </div>
  )
}

export default Tabbar
